<template>
    <section class="py-10 px-5 relative isolate">
        <div class="w-full justify-center flex" v-if="image_url">
            <img v-if="image_url" :src="image_url" :srcset="image_srcset" :sizes="image_srcset ? image_sizes : undefined"
                :width="image_width" :height="image_height" alt=""
                class="gradient-border " fetchpriority="high" />
        </div>
    </section>
</template>

<script lang="ts">
import { capture } from '~/services/analytics';

export default {
    props: {
        image_url: String,
        // Intrinsic pixel size of image_url, used to reserve layout space and avoid CLS.
        image_width: Number,
        image_height: Number,
        // Optional responsive-image srcset/sizes (see TICKET-10191). Omitted, the
        // <img> just uses image_url as before.
        image_srcset: String,
        image_sizes: String,
        bg: Boolean,
        posthog_view_event: String,
        posthog_view_properties: Object,
    },
    mounted() {
        if (this.posthog_view_event) {
            capture(this.posthog_view_event, this.posthog_view_properties);
        }
    },
};
</script>
